// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"8051b89c","273":"d3979849","319":"fe834d95","396":"ad5f3553","470":"b9d8822a","580":"cdd30174","586":"926b1ad3","738":"5ea882e6","917":"fe834d95","939":"cdd30174"}[chunkId] + ".chunk.css";
};